import { ReplayScreen } from "../../features/replay";

/** FS-14 리플레이 뷰어(역할 any — 학생 · 교사 둘 다 연다) — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/replay */
export default function ReplayPage() {
  return <ReplayScreen />;
}
